import { createApp } from 'vue'
import App from './App.vue'
import './assets/font.css'

createApp(App).mount('#app')
